import React, { Component, Fragment } from 'react';
import cx from 'classnames';
import {
  bool,
  element,
  func,
  number,
  instanceOf,
  string,
  shape,
  arrayOf,
  object,
  objectOf,
  any
} from 'prop-types';
import { get, sumBy, isEmpty } from 'lodash';
import {
  FormControlLabel,
  Switch,
  Divider,
  Typography
} from '@material-ui/core';
import {
  Schedule,
  DateRange,
  ArrowUpward,
  ArrowDownward
} from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import ReactDOMServer from 'react-dom/server';
import ToggleButtonGroup from '../../components/ToggleButtonGroup';
import Select from '../../components/Select';
import styles from './styles.scss';
import {
  campaignRangeToString,
  formatCutOverDate,
  formatCutOverDateByTimeRange,
  withInRange,
} from '../../helpers/formatData';
import { advertiserShape } from '../../helpers/propTypes';
import { newAdUsersMetricKey } from '../../helpers/constant';
import GADataChart from './GADataChart';
import DateRangeComponent from '../../components/DateRange';
import PeformanceSummary from '../PerformanceSummary';
import WebTable from '../DashboardTab/WebAnalytics/WebTable';
import ModuleExport from '../ModuleExport';
import {
  getNumberDifferenceDays,
  getChartData
} from '../../helpers/formatData';
import {
  GA_CHART_ID,
  FIRST_VALUE,
  SECOND_VALUE,
  FIRST_COLOR_CHART,
  SECOND_COLOR_CHART,
  newAdUsersKey,
} from '../../helpers/constant';
import {
  checkEnableFeatureFlag,
  shouldShowNewAdUserSunsetDisclaimer,
  shouldShowTileByDateCompare,
} from '../../helpers/common';
import DeleteReportItemButton from '../DeleteReportItem';
import { NewAdUserSunsetDisclaimer, UASunsetDisclaimer } from '../DashboardTab/ChartDisclaimer';

const muiStyles = {
  timeSelect: {
    marginLeft: '10px'
  },
  formControlLabelText: {
    fontSize: '14px'
  }
};

const listItemSelectedGAData = [
  {
    type: 'visit',
    label: 'Total Visits',
    shortLabel: 'Total Visits'
  },
  {
    type: 'adVisit',
    label: 'Ad Visits',
    shortLabel: 'Ad Visits'
  },
  {
    type: newAdUsersKey,
    label: 'New Ad Users',
    shortLabel: 'New Ad Users',
    requiredFeatureFlags: [
      newAdUsersMetricKey
    ]
  }
];

const listItemSelectedTime = [
  {
    label: 'By Date',
    timeRange: 'daily',
    icon: <DateRange style={{ fontSize: '18px' }} />,
    tableTitle: 'Date'
  },
  {
    label: 'By Hour',
    timeRange: 'hourly',
    icon: <Schedule style={{ fontSize: '18px' }} />,
    tableTitle: 'Hour'
  }
];
const initialSortByVisitPerAd = { sortKey: 'visitsPerAd', sortType: 'desc' };
const initialSortByDate = { sortKey: 'sortTimeKey', sortType: 'desc' };
const initialSortByNewAdUsersPerAds = { sortKey: 'newAdUsersPerAds', sortType: 'desc' };

const totalLabel = 'Total';
const dailyAVGLabel = 'Daily Avg.';
const changeLabel = 'Change';
const firstCalendarType = 'firstCalendar';
const secondCalendarType = 'secondCalendar';
const firstCalendarTitle = 'Current';
const secondCalendarTitle = 'Compare';
export const TIME_RANGE_VALUE = 'timeRange';
export const DAILY_RANGE_VALUE = 'daily';

export class GADataContainer extends Component {
  static propTypes = {
    data: shape({
      user: shape({
        daily: arrayOf(object),
        hourly: arrayOf(object)
      }),
      visit: shape({
        daily: arrayOf(object),
        hourly: arrayOf(object)
      })
    }),
    inpdf: bool,
    advertiser: advertiserShape,
    changeDateRange: func,
    showToast: func,
    campaign: shape({
      campaign_id: number.isRequired,
      masterCalendar: shape({
        selected: shape({
          start: instanceOf(Date),
          end: instanceOf(Date)
        })
      }),
      isCompare: bool,
      typeSelect: string,
      timeForChart: shape(element)
    }),
    setChartSelector: func,
    onChangeMasterDatePicker: func,
    onChangeSecondDatePicker: func,
    title: string,
    dataWebAnalytics: objectOf(
      shape({
        user: object,
        adUser: object,
        visit: object,
        adVisit: object,
        newAdUsers: object,
      })
    ),
    onCellClick: func,
    page: number,
    isChartVisible: bool,
    isChartVisibleReport: shape({
      isWebChartVisible: bool,
      isWebTableVisible: bool
    }),
    isTableDisplay: bool,
    rowsPerPage: number,
    isGrandTotalDisplay: bool,
    range: string,
    showDeleteWebItem: shape({
      showDeleteWebAnalyticsChart: bool,
      showDeleteWebAnalyticsTable: bool
    }),
    isCustomReport: bool,
    currentStep: string,
    displayWebAnalyticsChart: bool,
    itemIndex: number,
    webChartSelector: objectOf(string),
    setReportChartSelector: func,
    tableSortSelector: shape({
      sortKey: string,
      sortType: string
    }),
    classes: shape({ any }),
    formControlLabel: string,
    enabledFlags: arrayOf(string),
    isShouldShowSunsetDisclaimer: bool,
    rowsFirstPage: number
  };

  static defaultProps = {
    title: 'Web',
    showDeleteWebItem: {},
    formControlLabel: 'Compare Dates',
  };

  handleSetReportChartSelector = chartSelector => {
    const { isCustomReport, setReportChartSelector, itemIndex } = this.props;
    isCustomReport &&
      setReportChartSelector &&
      setReportChartSelector(GA_CHART_ID, itemIndex, chartSelector);
  };

  handleChangeComparative = event => {
    const { campaign, setChartSelector } = this.props;
    setChartSelector(campaign.campaign_id, GA_CHART_ID, { isCompare: event.target.checked });
    this.handleSetReportChartSelector({ isCompare: event.target.checked });
  };

  handleChangeSelectedGAData = value => {
    const { setChartSelector, campaign } = this.props;
    setChartSelector(campaign.campaign_id, GA_CHART_ID, { type: value.type });
    this.handleSetReportChartSelector({ type: value.type });
  };

  handleChangeSelectedTime = value => {
    const { setChartSelector, campaign } = this.props;
    const timeRange = value.timeRange || value;
    setChartSelector(campaign.campaign_id, GA_CHART_ID, { timeRange });
    this.handleSetReportChartSelector({ timeRange });
  };

  prepCsvData(data, isCompare, range, compareRange) {
    const csvTitle = ['Time', range];
    isCompare && csvTitle.push(compareRange);
    return (
      data &&
      data.reduce(
        (accum, currentEntry) => {
          const { time, firstValue, secondValue } = currentEntry;
          const csvData = [time, firstValue];
          isCompare && csvData.push(secondValue);
          accum.push(csvData);
          return accum;
        },
        [csvTitle]
      )
    );
  }

  drawDateOptions() {
    const dateRangeOptions = [
      {
        value: 'daily',
        label: 'Daily'
      },
      {
        value: 'weekly',
        label: 'Weekly'
      },
      {
        value: 'monthly',
        label: 'Monthly'
      }
    ];

    const { webChartSelector } = this.props;
    const timeRange = get(
      webChartSelector,
      [TIME_RANGE_VALUE],
      DAILY_RANGE_VALUE
    );

    return (
      <ToggleButtonGroup
        buttons={dateRangeOptions}
        selectedValue={timeRange}
        onSelectionChange={this.handleChangeSelectedTime}
        className={cx({ [styles.hidden]: timeRange === 'hourly' })}
      />
    );
  }

  setLabelAndType = () => {
    const { webChartSelector, enabledFlags } = this.props;
    const [firstType, secondType, ...remainTypes ] = listItemSelectedGAData;
    const type = get(webChartSelector, 'type', firstType.type);
    const typeObj = remainTypes.find(e => e.type === type);

    const isNewAdUserEnabled = enabledFlags.includes(newAdUsersMetricKey);

    let shortLabel = '';
    let valueForTypeSelect = '';

    switch (type) {
      case secondType.type:
        shortLabel = secondType.shortLabel;
        valueForTypeSelect = secondType;
        break;
      case firstType.type:
        shortLabel = firstType.shortLabel;
        valueForTypeSelect = firstType;
        break;
      default:
        // If newAdUsers is disabed for org, we should use default first type instead of newAdUsers
        // Todo: Make this more dynamic
        if (!isNewAdUserEnabled && type === newAdUsersKey) {
          shortLabel = firstType.shortLabel;
          valueForTypeSelect = firstType;
        } else {
          shortLabel = typeObj ? typeObj.shortLabel : firstType.shortLabel;
          valueForTypeSelect = typeObj || firstType;
        }
    }
    return { shortLabel, valueForTypeSelect };
  };

  handleCellClick = data => {
    const { webChartSelector, onCellClick } = this.props;
    const timeRange = get(
      webChartSelector,
      [TIME_RANGE_VALUE],
      DAILY_RANGE_VALUE
    );
    onCellClick && onCellClick(data, GA_CHART_ID, timeRange);
  };

  getFilterOptions = () => {
    const {
      enabledFlags,
      advertiser,
      campaign
    } = this.props;
    const options = listItemSelectedGAData.filter(o => checkEnableFeatureFlag(enabledFlags, o.requiredFeatureFlags));
    const isNewAdUserSelectorShow = shouldShowTileByDateCompare({advertiser, campaign});
    const filterOptions = isNewAdUserSelectorShow ? options : options.filter((obj) => obj.type !== newAdUsersKey); 
    return filterOptions;
  }

  renderChange = change => {
    let icon = <ArrowUpward />;
    let className = styles.same;
    let label = 'N/A';

    if (change < 0) {
      icon = <ArrowDownward />;
      className = styles.decrease;
      label = `${change.toLocaleString()}%`;
    } else if (change > 0) {
      className = styles.increase;
      label = `+${change.toLocaleString()}%`;
    }

    return (
      <div className={className}>
        {icon} <span>{label}</span>
      </div>
    );
  };

  exportContainer = React.createRef();
  render() {
    const {
      data,
      inpdf,
      changeDateRange,
      showToast,
      advertiser,
      campaign,
      onChangeMasterDatePicker,
      onChangeSecondDatePicker,
      title,
      dataWebAnalytics,
      range,
      page,
      isChartVisible,
      isChartVisibleReport,
      isTableDisplay,
      rowsPerPage,
      isGrandTotalDisplay,
      isCustomReport,
      showDeleteWebItem,
      currentStep,
      displayWebAnalyticsChart,
      itemIndex,
      webChartSelector,
      tableSortSelector,
      classes,
      formControlLabel,
      enabledFlags,
      isShouldShowSunsetDisclaimer,
      rowsFirstPage
    } = this.props;

    const [firstType] = listItemSelectedGAData;
    const [firstTime, secondTime] = listItemSelectedTime;
    const type = get(webChartSelector, 'type', firstType.type);
    const timeRange = get(
      webChartSelector,
      [TIME_RANGE_VALUE],
      DAILY_RANGE_VALUE
    );
    const valueForTimeSelect = timeRange !== 'hourly' ? firstTime : secondTime;
    let defaultSortStatus = initialSortByDate;
    if (timeRange === 'hourly') {
      defaultSortStatus = initialSortByVisitPerAd;
      if (type === newAdUsersKey) {
        defaultSortStatus = initialSortByNewAdUsersPerAds;
      }
    }
    const initialSortStatus = tableSortSelector || defaultSortStatus;
    const isCompare = get(webChartSelector, 'isCompare', false);
    const firstCalendar = get(campaign, [firstCalendarType, 'selected']);
    const secondCalendar = get(campaign, [secondCalendarType, 'selected']);
    const firstRange = campaignRangeToString(firstCalendar);
    const secondRange = campaignRangeToString(secondCalendar);
    const numberDays = getNumberDifferenceDays(firstCalendar);
    const dataSelected = timeRange && get(data, [type, timeRange], []);
    const chartData = dataSelected.map(datum => {
      const clonedData = { ...datum };
      !isCompare && delete clonedData.secondValue;
      return {
        ...clonedData,
        change:
          isCompare &&
          ReactDOMServer.renderToString(this.renderChange(clonedData.change))
      };
    });

    const disabledChange = !chartData || isEmpty(chartData);
    const { shortLabel, valueForTypeSelect } = this.setLabelAndType();

    const currentValueTotal = sumBy(chartData, FIRST_VALUE);
    const previousValueTotal = sumBy(chartData, SECOND_VALUE);
    const currentValueAvg =
      numberDays === 0 ? 0 : (currentValueTotal / numberDays).toFixed(1);
    const previousValueAvg =
      numberDays === 0 ? 0 : (previousValueTotal / numberDays).toFixed(1);
    const primaryTitle = `${shortLabel}`;
    const secondaryTitle = `${dailyAVGLabel} ${shortLabel}`;
    const totalChange = `${totalLabel} ${changeLabel}`;
    const dailyAvgChange = `${dailyAVGLabel} ${changeLabel}`;
    const csvData = this.prepCsvData(
      chartData,
      isCompare,
      firstRange,
      secondRange
    );
    const fileName = `web_${shortLabel.toLowerCase()}`;
    const _isTableDisplay = !inpdf || (isTableDisplay && inpdf);
    const allCampaignData = getChartData(campaign);
    const campaignAvgAdCost = get(allCampaignData, 'avgAdCost', null);
    const { isWebChartVisible, isWebTableVisible } = isChartVisibleReport;
    const {
      showDeleteWebAnalyticsChart,
      showDeleteWebAnalyticsTable
    } = showDeleteWebItem;
    const isDisplayChart =
      (!isCustomReport && isChartVisible) ||
      (isCustomReport && isWebChartVisible);
    const isDisplayTable =
      (!isCustomReport && _isTableDisplay) ||
      (isCustomReport && isWebTableVisible);
    const isDisplayChartContainer =
      (!inpdf && (isDisplayChart || isDisplayTable)) ||
      (inpdf && isDisplayChart);
      const isNewAdUserEnabled = enabledFlags.includes(newAdUsersKey);
    const ga4CutOverDate = get(advertiser, 'google_analytics_cutover_date');
    const timezoneKey = get(campaign, 'timezoneSetting.timezoneKey');
    let cutOverDate;
    if (
      ga4CutOverDate &&
      timeRange !== 'hourly' &&
      withInRange({
        dateRange: firstCalendar,
        comparedDate: ga4CutOverDate,
        timezoneKey,
      })
    ) {
      cutOverDate = formatCutOverDateByTimeRange({
        cutOverDate: ga4CutOverDate,
        timeRange,
        campaignDateRange: firstCalendar,
        timezoneKey,
      });
    }
    const cutOverDateTooltip = `Web data source updated on ${formatCutOverDate({ cutOverDate: ga4CutOverDate, timezoneKey })}`;
    const filterOptions = this.getFilterOptions();

    return (
      <div
        className={cx(
          { [styles.gaContainerMainView]: !isCustomReport },
          styles.gaContainer
        )}
      >
        {isDisplayChartContainer && (
          <div
            className={cx({
              [styles.itemContainer]: showDeleteWebAnalyticsChart,
              [styles.deleteItemContainer]:
                currentStep === 'customize' && isWebChartVisible
            })}
          >
            {showDeleteWebAnalyticsChart && isDisplayChart && (
              <DeleteReportItemButton
                isDelete={showDeleteWebAnalyticsChart}
                parentId="webAnalytics"
                componentId="webAnalyticsChart"
                customClassName={styles.deleteButton}
                itemIndex={itemIndex}
              />
            )}
            {isDisplayChart && (
              <Fragment>
                <ModuleExport
                  exportImg={this.exportContainer}
                  data={csvData}
                  fileName={fileName}
                  disableCsvExport
                />
                <div className={styles.switchControl}>
                  <FormControlLabel
                    control={
                      <Switch
                        disabled={inpdf || disabledChange}
                        onChange={this.handleChangeComparative}
                        checked={isCompare}
                        color="primary"
                        data-test="compareDateBtn"
                      />
                    }
                    label={
                      <Typography className={classes.formControlLabelText}>
                        {formControlLabel}
                      </Typography>
                    }
                    data-veritone-element="compare-dates"
                  />
                </div>
              </Fragment>
            )}
            <div
              data-test="webChart"
              className={styles.exportContainer}
              ref={this.exportContainer}
            >
              <div className={styles.webTitle}>
                <div data-test="webChartTitle" className={styles.webTitleText}>
                  {title}
                </div>
                {
                  isShouldShowSunsetDisclaimer && <UASunsetDisclaimer />
                }
              </div>
              <div className={styles.selectControl}>
                <Select
                  listItem={filterOptions}
                  value={valueForTypeSelect}
                  onChange={this.handleChangeSelectedGAData}
                  disabled={disabledChange}
                />
                <Select
                  listItem={listItemSelectedTime}
                  value={valueForTimeSelect}
                  onChange={this.handleChangeSelectedTime}
                  className={classes.timeSelect}
                  disabled={disabledChange}
                />
                <div className={cx(styles.timeRangeSelector)}>
                  {this.drawDateOptions()}
                </div>
              </div>
              {isDisplayChart && (
                <div className={styles.content}>
                  <div className={styles.chartBox}>
                    <GADataChart
                      data={chartData}
                      selectBy={shortLabel}
                      firstRange={firstRange}
                      secondRange={secondRange}
                      isCompare={isCompare}
                      cutOverDate={cutOverDate}
                      cutOverDateTooltip={cutOverDateTooltip}
                    />
                  </div>
                  <div className={styles.dateRangeControl}>
                    <DateRangeComponent
                      campaign={campaign}
                      changeDateRange={changeDateRange}
                      advertiser={advertiser}
                      showToast={showToast}
                      typePicker={firstCalendarType}
                      disabled={!isCompare}
                      onChange={onChangeMasterDatePicker}
                      title={firstCalendarTitle}
                      isShowDataCollected
                      styleForDateRange={{
                        styleIconCalendar: styles.firstCalendar,
                        container: styles.containerCalendar
                      }}
                    />
                    {!isCompare && (
                      <div className={styles.GADataContainer}>
                        <div className={styles.dataContainer}>
                          <div className={styles.dataTitle}>{primaryTitle}</div>
                          <div
                            data-test="primaryValue"
                            className={styles.dataMetric}
                          >
                            {Math.round(currentValueTotal).toLocaleString()}
                          </div>
                        </div>
                        <div className={styles.dataContainer}>
                          <div className={styles.dataTitle}>
                            {secondaryTitle}
                          </div>
                          <div
                            data-test="secondaryValue"
                            className={styles.dataMetric}
                          >
                            {Math.round(currentValueAvg).toLocaleString()}
                          </div>
                        </div>
                      </div>
                    )}
                    {isCompare && (
                      <Fragment>
                        <DateRangeComponent
                          campaign={campaign}
                          changeDateRange={changeDateRange}
                          advertiser={advertiser}
                          showToast={showToast}
                          typePicker={secondCalendarType}
                          disabled={!isCompare}
                          onChange={onChangeSecondDatePicker}
                          title={secondCalendarTitle}
                          isShowDataCollected
                          styleForDateRange={{
                            styleIconCalendar: styles.secondCalendar,
                            container: styles.containerCalendar
                          }}
                        />

                        <Divider className={styles.divider} />

                        <div className={styles.performanceBox}>
                          <PeformanceSummary
                            primaryData={currentValueTotal}
                            secondaryData={previousValueTotal}
                            primaryTitle={primaryTitle}
                            secondaryTitle={primaryTitle}
                            evaluationResultTitle={totalChange}
                            primaryDataStyle={{ color: FIRST_COLOR_CHART }}
                            secondaryDataStyle={{ color: SECOND_COLOR_CHART }}
                          />
                          <PeformanceSummary
                            primaryData={currentValueAvg}
                            secondaryData={previousValueAvg}
                            primaryTitle={secondaryTitle}
                            secondaryTitle={secondaryTitle}
                            evaluationResultTitle={dailyAvgChange}
                            primaryDataStyle={{ color: FIRST_COLOR_CHART }}
                            secondaryDataStyle={{ color: SECOND_COLOR_CHART }}
                            isShowChangePercent={false}
                          />
                        </div>
                      </Fragment>
                    )}
                  </div>
                  {shouldShowNewAdUserSunsetDisclaimer(
                    campaign,
                    valueForTypeSelect.type === newAdUsersKey
                  ) && <NewAdUserSunsetDisclaimer />}
                </div>
              )}
            </div>
          </div>
        )}
        {isDisplayTable ? (
          <div
            className={cx({
              [styles.itemContainer]: showDeleteWebAnalyticsTable,
              [styles.deleteItemContainer]: currentStep === 'customize'
            })}
          >
            {showDeleteWebAnalyticsTable && (
              <DeleteReportItemButton
                isDelete={showDeleteWebAnalyticsTable}
                parentId="webAnalytics"
                componentId="webAnalyticsTable"
                customClassName={styles.deleteButton}
                itemIndex={itemIndex}
              />
            )}
            <WebTable
              inpdf={inpdf}
              valueForTimeSelect={valueForTimeSelect}
              timeRange={timeRange}
              dataWebAnalytics={dataWebAnalytics}
              valueForTypeSelect={valueForTypeSelect}
              campaign={campaign}
              range={range}
              onCellClick={this.handleCellClick}
              page={page}
              isChartVisible={isChartVisible}
              isCustomReport={isCustomReport}
              isWebChartVisible={displayWebAnalyticsChart}
              rowsPerPage={rowsPerPage}
              isGrandTotalDisplay={isGrandTotalDisplay}
              campaignAvgAdCost={campaignAvgAdCost}
              initialSortStatus={initialSortStatus}
              tableIndex={itemIndex}
              isNewAdUserEnabled={isNewAdUserEnabled}
              rowsFirstPage={rowsFirstPage}
            />
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

import { connect } from 'react-redux';
import { getTableSortSelector } from '../DashboardTab/Report/helper';

function mapStateToProps(state, props) {
  return {
    currentStep: get(state, 'reportBuilder.currentStep', ''),
    tableSortSelector: getTableSortSelector(state, props, GA_CHART_ID)
  };
}

export default connect(mapStateToProps)(withStyles(muiStyles)(GADataContainer));